import { render, staticRenderFns } from "./FailedIcon.vue?vue&type=template&id=863680c4"
import script from "./FailedIcon.vue?vue&type=script&lang=js"
export * from "./FailedIcon.vue?vue&type=script&lang=js"
import style0 from "./FailedIcon.vue?vue&type=style&index=0&id=863680c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports